module.exports = __webpack_public_path__ + "assets/images/$1HL.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/$1HL.png
// module id = 1246
// module chunks = 1